import { useEffect, useState } from 'react';
import { apiClient } from '../api/axios';
import { useAuthStore } from '../store/authStore';

/**
 * After reload, tokens are gone from memory (refresh is an httpOnly cookie).
 * Restore a silent access token before routes fire API calls.
 */
export function useSessionBootstrap() {
  const [ready, setReady] = useState(() => {
    const { user, accessToken, isAuthenticated } = useAuthStore.getState();
    return !isAuthenticated || !user || Boolean(accessToken);
  });

  useEffect(() => {
    if (ready) return;

    let cancelled = false;

    const restore = async () => {
      try {
        const response = await apiClient.post('/auth/refresh', {});
        const payload = response.data.data ?? response.data;
        if (!cancelled && payload?.accessToken) {
          useAuthStore.getState().updateTokens(
            payload.accessToken,
            payload.refreshToken,
          );
        } else {
          useAuthStore.getState().logout();
        }
      } catch {
        if (!cancelled) {
          useAuthStore.getState().logout();
        }
      } finally {
        if (!cancelled) setReady(true);
      }
    };

    void restore();
    return () => {
      cancelled = true;
    };
  }, [ready]);

  return ready;
}
